var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.44,
    height: 20.438,
    viewBox: "0 0 20.44 20.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-report-3476452",
    transform: "translate(-1.997 -2.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4617",
    "data-name": "Raggruppa 4617",
    transform: "translate(1.997 2.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9577",
    "data-name": "Tracciato 9577",
    d: "M12.237,22.489a10.181,10.181,0,0,0,6.694-2.51l-7.211-7.21a.731.731,0,0,1-.215-.518V2.051a10.232,10.232,0,0,0,.731,20.438Z",
    transform: "translate(-1.997 -2.051)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9578",
    "data-name": "Tracciato 9578",
    d: "M17,2.051V11.52h9.469A10.237,10.237,0,0,0,17,2.051Z",
    transform: "translate(-6.029 -2.051)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9579",
    "data-name": "Tracciato 9579",
    d: "M18.414,17l5.963,5.963A10.178,10.178,0,0,0,26.849,17Z",
    transform: "translate(-6.409 -6.069)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.501f421b9011f7dd98fb15adf0d1a764.svg";
export { ForwardRef as ReactComponent };